import React from 'react';

export const SkuFileArchiveContext = React.createContext({});
